const data = {
    meta : {
        title       : "Team - Developer Software, Website dan Aplikasi Mobile Terbaik di Makassar",
        description : "Mari mengenal dekat para pakar dibidangnya masing – masing, yang siap membantu menyelesaikan masalah anda dengan pendekatan kreatif dan inovatif.",
        imageUrl    : "/images/banner/banner-2.png",
        imageAlt    : "/images/banner/banner-2.png"
    },
    banner : {
        id : {
            title : "KELUARGA WASD Labs",
            subTitle : "Mari mengenal dekat para pakar dibidangnya masing – masing, yang siap membantu menyelesaikan masalah anda dengan pendekatan kreatif dan inovatif."
        }
    },
    detail : {
        id : {
            about : "Tentang Saya",
            skill : "Keterampilan Saya",
            say   : "Katakan Halo",
            team  : "Tim Kami"
        }
    }
}

export default data